<template>
  <div :class="['search-bar']">
    <form @submit.prevent="submit">
      <vc-text clearable name="search" v-model="q" type="text" :color="categoryColor" icon-left="search" placeholder="Search..." />
    </form>
  </div>
</template>
<script>
export default {
  name: 'SearchBar',
  data () {
    return {
      q: ''
    }
  },
  computed: {
    categoryColor () {
      return this.$store.getters.categoryColor
    }
  },
  methods: {
    submit () {
      const q = this.q
      if (!q || q.length < 2) {
        return
      }
      this.$router.push({
        path: '/search',
        query: {
          q: q
        }
      }, () => {
        this.q = null
      })
    }
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/search-bar/SearchBar.vue